/* eslint-disable react/prop-types */

import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import "./Filters.css";
import { motion } from "framer-motion";

export const Filters = ({
    isLoading,
    error,
    categories,
    allIsActive,
    handleChangeAllFilter,
    isSelected,
    selectCategory,
}) => {
    console.log("CATEGORIES RENDER");
    
    // console.log("IS LOADING: ", isLoading);

    if (isLoading)
        return (
            <div className="filter-button-container">
                <SkeletonTheme baseColor="#202020" highlightColor="#444">
                    {[0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0].map(
                        (e, i) => (
                            <Skeleton
                                key={i}
                                className="filter-button"
                                width={100}
                            />
                        )
                    )}
                </SkeletonTheme>
            </div>
        );
    if (error)
        return <div className="">Oops! An error ocurred: {error.message}</div>;

    return (
        <div className="filter-button-container">
            <div
                className={`filter-button ${allIsActive ? "active" : ""}`}
                onClick={handleChangeAllFilter}
            >
                All
            </div>
            {categories.map((category) => (
                <motion.div
                    key={category.id}
                    className="box"
                    whileHover={{ scale: 1.1 }}
                    whileTap={{ scale: 0.9 }}
                    transition={{
                        type: "spring",
                        stiffness: 400,
                        damping: 17,
                    }}
                >
                    <div
                        className={`filter-button ${
                            isSelected(category.id) ? "active" : ""
                        }`}
                        onClick={() => selectCategory(category.id)}
                    >
                        {category.name}
                    </div>
                </motion.div>
            ))}
        </div>
    );
};
